import { Injectable } from '@angular/core';
import { Adapter } from '../../../../interfaces/Adapter';
import { EmployeeRoleEnum } from '../../../enums/EmployeeRoleEnum';

/**
 * An adapter converts employee role HTTP response to domain object.
 */
@Injectable({
  providedIn: 'root'
})
export class EmployeeRoleAdapter implements Adapter<EmployeeRoleEnum> {

  /**
   * Converts employee role HTTP response to {@link EmployeeRoleEnum}.
   * @param item employee role HTTP response.
   */
  adapt(item: string): EmployeeRoleEnum {
    return employeeRolesMap().get(item);
  }
}

function employeeRolesMap(): Map<string, EmployeeRoleEnum> {
  const employeeRoleValues = new Map<string, EmployeeRoleEnum>();
  employeeRoleValues.set('General Manager', EmployeeRoleEnum.GENERAL_MANAGER);
  employeeRoleValues.set('Assistant Manager', EmployeeRoleEnum.ASSISTANT_MANAGER);
  employeeRoleValues.set('Senior Sales Advisor', EmployeeRoleEnum.SENIOR_SALES_ADVISOR);
  employeeRoleValues.set('Sales Advisor', EmployeeRoleEnum.SALES_ADVISOR);
  employeeRoleValues.set('Customer Experience Advisor', EmployeeRoleEnum.CUSTOMER_EXPERIENCE_ADVISOR);
  return employeeRoleValues;
}
